import React from "react";
import { LegalPage } from "@/components/LegalPage";

export default function Terms() {
  return <LegalPage docKey="terms" testId="legal-terms-screen" />;
}
